import { render, staticRenderFns } from "./size-comp.vue?vue&type=template&id=8f79ba16&scoped=true"
import script from "./size-comp.vue?vue&type=script&lang=js"
export * from "./size-comp.vue?vue&type=script&lang=js"
import style0 from "./size-comp.vue?vue&type=style&index=0&id=8f79ba16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f79ba16",
  null
  
)

export default component.exports